import { useEffect, useRef, useState } from 'react';
import organizationsApi from 'api/organizationsApi';
import { MentionUser } from 'components/Editor/plugins/mentionUtils';

/**
 * Membri dell'organizzazione per l'autocomplete delle menzioni.
 * Riusa l'endpoint paginato `/organizations/{id}/users` con ricerca server-side
 * sul parametro `name`. Debounce di 200ms per non chiamare a ogni tasto.
 */
export function useOrganizationMembers(orgId?: number, query: string = '') {
  const [members, setMembers] = useState<MentionUser[]>([]);
  const [loading, setLoading] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!orgId) {
      setMembers([]);
      return;
    }
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await organizationsApi.get(`${orgId}/users`, {
          params: { name: query },
        });
        setMembers(
          (data?.users ?? []).map((u: any) => ({
            id: u.id,
            firstname: u.firstname,
            lastname: u.lastname,
            email: u.email,
          }))
        );
      } catch {
        setMembers([]);
      } finally {
        setLoading(false);
      }
    }, 200);
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, [orgId, query]);

  return { members, loading };
}

export default useOrganizationMembers;
